import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useTranslation } from 'react-i18next';
import styles from './About.module.scss';

const About = () => {
  const { t } = useTranslation();
  const [ref, inView] = useInView({
    threshold: 0.3,
    triggerOnce: true
  });

  return (
    <section ref={ref} className={styles.about} id="about">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8 }}
        className={styles.content}
      >
        <div className={styles.intro}>
          <motion.div 
            className={styles.profileImage}
            initial={{ opacity: 0, scale: 0.5 }}
            animate={inView ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 0.5 }}
          >
            <img src="/me.jpg" alt={t('about.name')} />
          </motion.div>
          <h1>{t('about.name')}</h1>
          <h2>{t('about.title')}</h2>
          <div className={styles.contact}>
            <a href={`mailto:${t('about.contact.email')}`}>{t('about.contact.email')}</a>
            <a href={`tel:${t('about.contact.phone')}`}>{t('about.contact.phone')}</a>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default About; 